var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-time-picker',_vm._g(_vm._b({staticClass:"core-time-picker",attrs:{"popper-class":"core-time-picker-popper","size":"large"}},'el-time-picker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }